import { useQuery } from '@tanstack/react-query';

import { getProductCategories } from '../queries/products';
import { useBuyerHomeQueryGate } from './useBuyerHomeQueryGate';

export const useGetProductCategory = (size: number, page: number) => {
  const { canQuery, queryToken } = useBuyerHomeQueryGate();
  return useQuery({
    queryKey: ['ProductCategory', size, page],
    queryFn: () => getProductCategories(queryToken, { size, page }),
    enabled: canQuery,
  });
};
